export const originSection = () => {
  const path = location.pathname

  if (path.includes('attendance')) {
    return 'Time tracking section'
  } else if (path.includes('contributors')) {
    return 'People section'
  } else {
    return 'My projects section'
  }
}
